import * as config from './config';

export default class Style {
  constructor() {
    this.style = '';
    this.ids = {};
  }

  clear() {
    this.style = '';
  }

  bindIdToClass(id, className) {
    if (!this.ids[className]) {
      this.ids[className] = [];
    }

    if (this.ids[className].includes(id)) {
      return false;
    }

    this.ids[className].push(id);

    return true;
  }

  bindAllClassesIds() {
    const classNames = Object.keys(this.ids);

    classNames.forEach(className => {
      this.defineClass(className, config.STEP_CLASSES_DEFINITIONS[className]);
      this.style += `class ${this.ids[className].join()} ${className}\n`;
    });
  }

  defineClass(className, definitions) {
    this.style += `classDef ${className} ${definitions}\n`;
  }

  get() {
    this.bindAllClassesIds();
    return this.style;
  }

}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/style.js
 **/